<template>
	<div class="tusd-wrap wrap-bg header-scroll">
		<div class="page-title"><i class="back-btn" @click="goBack()"></i>收款账号</div>
		<cube-scroll-nav-bar :current="currentStatus" :labels="status" :txts="txts" @change="changeNav" />
		<div class="separator"></div>
		<cube-slide class="order-scroll" :options="{ click: false }" :showDots="false" :initialIndex="crtIndex"
			:autoPlay="false" :loop="false">
			<cube-slide-item>
				<cube-scroll>
					<div class="add-account">
						<div @click="goPage('addAccount', 'bank')"> <span><i class="add-i"></i>添加账户</span>
						</div>

						<div @click="goPage('bankGroupManage', 'bank')">
							<span><i class="group-i"></i>分组管理</span>
						</div>
					</div>

					<div class="bankgroup-list">
						<div class="bankgroup-item box-wrap" v-for="group in bankListGroups" :key="group.Id">
							<div class="bankgroup-item-operation">
								<span>状态：{{ group.IsUse == 1 ? '已启用' : '已关闭' }} &nbsp;&nbsp; | &nbsp;&nbsp;{{
									group.Title
								}}&nbsp; ({{ group.BankCount }})</span>
								<div>&nbsp;</div>
								<span>
									{{ group.ServiceTimeShow }}
								</span>
								<span v-if="!group.IsExpanded" class="bankgroup-item-operation-btn"
									@click="showBankList(group)">展开&nbsp;<i class="more-on"></i></span>
								<span v-if="group.IsExpanded" class="bankgroup-item-operation-btn"
									@click="showBankList(group)">收起&nbsp;<i class="more-off"></i></span>
								<div class="accounts-list" v-if="group.IsExpanded">
									<div class="operation-item-switch">
										<span>全部启用</span>
										<cube-switch v-model="group.UseStatus" @input="changeBankIsUseStatus(group)"
											:disabled="group.BankList.length == 0">
											{{ group.IsUse == 1 ? '已启用' : '已关闭' }}
										</cube-switch>
									</div>
									<div class="account-item box-wrap" v-for="a in group.BankList" :key="a.ID"
										@click="goPage('editAccount', a)">
										<div class="icon-info">
											<div class="account-icon">
												<div class="icon-wrap">
													<img :src="a.Logo" alt="">
												</div>
											</div>
											<div class="account-info">
												<div class="name-no">
													<div class="name">{{ a.BankName }}</div>
													<div class="no">{{ a.BankUser }} {{ common.getBankNo(a.BankAccount)
													}}</div>
												</div>
												<div class="day-limit"></div>
											</div>
										</div>
										<div class="sigle-operation">
											<cube-switch v-model="a.Opened" @click.stop.native
												@input="changeSigleBankUseStatus(a, group)">
												{{ a.Opened ? '已启用' : '已关闭' }}
											</cube-switch>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


				</cube-scroll>
			</cube-slide-item>
			<cube-slide-item>
				<cube-scroll>
					<div class="add-account">
						<div @click="goPage('addAlipay', 'aliPay')"> <span><i class="add-i"></i>随机码</span>
						</div>
						<div @click="goPage('addFixedLimitQrcode', 'bank')"> <span><i class="add-i"></i>固额码</span>
						</div>
						<div @click="goPage('bankGroupManage', 'bank')">
							<span><i class="group-i"></i>分组管理</span>
						</div>
					</div>
					<div class="bankgroup-list">
						<div class="bankgroup-item box-wrap" v-for="group in aliPayListGroups" :key="group.Id">
							<div class="bankgroup-item-operation">
								<span>状态：{{ group.IsUse == 1 ? '已启用' : '已关闭' }} &nbsp;&nbsp; | &nbsp;&nbsp;{{
									group.Title
								}}&nbsp; ({{ group.BankCount }})</span>
								<div>&nbsp;</div>
								<span>
									{{ group.ServiceTimeShow }}
								</span>
								<span v-if="!group.IsExpanded" class="bankgroup-item-operation-btn"
									@click="showBankList(group)">展开&nbsp;<i class="more-on"></i> </span>
								<span v-if="group.IsExpanded" class="bankgroup-item-operation-btn"
									@click="showBankList(group)">收起&nbsp;<i class="more-off"></i> </span>
								<div class="accounts-list" v-if="group.IsExpanded">
									<div class="operation-item-switch">
										<div> <span>全部启用:</span></div>
										<div class="sigle-operation">
											<cube-switch v-model="group.UseStatus" @input="changeBankIsUseStatus(group)"
												:disabled="group.BankList.length == 0">
												{{ group.UseStatus ? '已启用' : '已关闭' }}
											</cube-switch>
										</div>
									</div>
									<div class="account-item box-wrap" v-for="a in group.BankList" :key="a.ID"
										@click="goPage('editAlipay', a)">
										<div class="icon-info">
											<div class="account-icon">
												<div class="icon-wrap">
													<img :src="a.Logo" alt="">
												</div>
											</div>
											<div class="account-info">
												<div class="name-no">
													<!-- <div class="name">{{ a.BankName }}</div> -->
													<div class="bank-user">{{ a.BankRemark }} </div>
													<div class="no">{{ common.getBankNo(a.BankAccount) }}</div>
													<div class="avilable-qr-count" v-if="a.AmountType == 2">
														金额：{{ a.AmountFixed }} | 可用收款码：{{ a.AvilableQrCodeCount }}个
													</div>
												</div>
												<div class="day-limit"></div>
											</div>
										</div>
										<div class="sigle-operation">
											<cube-switch v-model="a.Opened" @click.stop.native
												@input="changeSigleBankUseStatus(a, group)">
												{{ a.Opened ? '已启用' : '已关闭' }}
											</cube-switch>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


				</cube-scroll>
			</cube-slide-item>
		</cube-slide>

	</div>
</template>

<script>
export default {
	name: 'accounts',
	data() {
		return {
			//accounts:[],
			params: {},
			currentStatus: 1,
			crtIndex: 0,
			status: [1, 2],
			txts: [],
			scrollOptions: this.$store.state.refreshOptions,
			userBankListGroups: []
		}
	},

	computed: {
		bankListGroups() {
			return this.userBankListGroups.filter((item) => {
				return item.PayType == 1;
			});
		},
		aliPayListGroups() {
			return this.userBankListGroups.filter((item) => {
				return item.PayType == 2;
			});
		}
	},
	methods: {
		changeNav(sta) {
			this.currentStatus = sta
			let accountCurrent = {
				name: 'accountCurrent',
				currentStatus: sta
			}
			this.$store.commit('storeParams', accountCurrent)
			this.status.some((v, i) => {
				if (v == sta) {
					this.crtIndex = i
					return true
				}
			})
		},
		changeBankIsUseStatus(group) {
			this.updateBankGroupIsUse(group.Id, group.UseStatus);
		},
		changeSigleBankUseStatus(account, group) {
			var id = account.ID;
			var opened = account.Opened;
			this.$api.updateSingleAlipayAccount({ id, opened }).then(res => {
				this.$message.popup(res.msg, 1000);
				if (res.data == 1) {
					this.getUserBankGroups();
				}
			}).catch(res => {
				this.$message.popup(res.msg, 1000);
			});
		},
		updateBankGroupIsUse(id, status) {
			var isUse = status ? 1 : 0
			this.$api.updateBankGroupIsUse(id, isUse).then(res => {
				this.$message.popup(res.msg, 1000);
				this.getUserBankGroups()
			}).catch(res => {
				this.$message.popup(res.msg, 1000);
			});
		},
		showBankList(group) {
			group.IsExpanded = !group.IsExpanded;
		},
		getUserBankGroups() {
			this.$api.getUserBankGroups().then((res) => {
				this.userBankListGroups = res.data;
			})
		},
		goBack() {
			this.$router.push({ name: this.params.back })
			let accountCurrent = {
				name: 'accountCurrent',
				currentStatus: 1
			}
			this.$store.commit('storeParams', accountCurrent)

		},
		goPage(name, act) {
			if (act.AmountType == 2) {
				name = "editFixedLimitQrcode";
			}
			//console.log(act,name);
			let params = {
				name: name,
				back: 'accounts',
				currentStatus: this.currentStatus
			}
			if (act) {
				params = Object.assign(params, {
					bankId: act.ID
				})
			}

			let accountCurrent = {
				name: 'accountCurrent',
				currentStatus: this.currentStatus
			}
			this.$store.commit('storeParams', params)
			this.$store.commit('storeParams', accountCurrent)
			this.$router.push({ name: name })

		}
	},
	created() {
		this.getUserBankGroups();
		var userInfo = this.$store.state.userInfo;
		var txts = [];
		if (userInfo.PayTypeLimit.includes("1")) {
			txts.push('银行卡');
		}
		if (userInfo.PayTypeLimit.includes("2")) {
			txts.push('支付宝');
		}
		this.txts = txts;
		if (txts.length == 1) {
			this.crtIndex = parseInt(userInfo.PayTypeLimit) - 1;
		} else {
			this.crtIndex = parseInt(userInfo.PayTypeLimit[0]) - 1;
		}
		this.params = this.$store.state.routerStore.accounts
		if (this.$store.state.routerStore.accountCurrent) {
			this.changeNav(this.$store.state.routerStore.accountCurrent.currentStatus)
		}
		if (!this.params.back) {
			this.params.back = 'mine';
		}


	}
}
</script>

<style lang="less" scoped>
.bankgroup-list {
	padding: 14px @space;
	padding-bottom: 80px;

	.bankgroup-item {
		display: flex;
		justify-content: space-between;
		padding: 18px 14px;
		color: #fff;
		margin-bottom: 16px;

		.bankgroup-item-operation {
			line-height: 15px;
			/* 确保容器有足够的宽度 */
			width: 100%;

			/* 或其他具体宽度 */
			/* 清除浮动影响（可选，取决于后续布局） */
			//overflow: auto;
			.bankgroup-item-operation-btn {
				color: #fff;
				float: right;

				.more-on {
					float: right;
					width: 18px;
					height: 18px;
					background: url(../assets/images/off.svg) center center no-repeat;
				}

				.more-off {
					float: right;
					width: 18px;
					height: 18px;
					background: url(../assets/images/on.svg) center center no-repeat;
				}
			}

		}

		.accounts-list {
			padding-top: 20px;

			.operation-item-switch {
				display: flex;
				justify-content: space-between;
				margin-bottom: 15px;
			}

			.account-item {
				justify-content: space-between;
				padding: 16px ;
				color: #fff;
				margin-bottom: 16px;

				.icon-info {
					display: flex;

					.icon-wrap {
						width: 46px;
						height: 46px;
						margin-right: 14px;
						//background-color: #fff;
						background-size: cover;
						border-radius: 100%;  
						display: flex;
						align-items: center;
						justify-content: center;
						img {
							width: 38px; 
						}
					}

					.name-no {
						margin-bottom: 16px;

						.name {
							margin-bottom: 10px;
							font-size: 16px !important;
						}

						.no {
							font-size: 13px !important;
						}

						.avilable-qr-count {
							margin-top: 10px;
							font-size: 13px !important;
						}

						.bank-user {
							margin-bottom: 10px;
							font-size: 16px !important;
						}
					}

					.day-limit {
						font-size: 13px !important;
					}
				}

				.bank-info {
					display: flex;
					justify-content: space-between;
					flex-direction: column;
					text-align: right;

					.bank,
					.per-limit {
						font-size: 13px !important;
					}
				}


				&:nth-child(n) {
					background-image: linear-gradient(left, #fda399, #e36182);
				}

				&:nth-child(2n) {
					background-image: linear-gradient(left, #80bf5e, #2b9eb1);
				}

				&:nth-child(3n) {
					background-image: linear-gradient(left, #4fa5d3, #435dc1);
				}

				&:nth-child(4n) {
					background-image: linear-gradient(left, #e8ac67, #da9649);
				}
			}
		}

	}
}

.add-account {
	margin-top: 25px;
	text-align: center;
	color: #569eff;
	line-height: 28px;

	div {
		/* width: 45%; */
		/* 或者任何适合的值 */
		box-sizing: border-box;
		padding: 5px;
		background-color: #3c4468;
		border: 1px solid #3e4771;
		border-radius: 5px;
		margin: 1px 7px 8px 7px;
		display: inline-block;
		vertical-align: top;
		/* 可选，使div顶部对齐 */
	}

	span {
		// font-size: 17px !important;
		// background-color: #3c4468;
		// border: 1px solid #3e4771;
		// border-radius: 7px;
		font-size: 17px !important;
	}

	.add-i {
		display: inline-block;
		vertical-align: middle;
		width: 28px;
		height: 28px;
		margin-right: 8px;
		background: url(../assets/images/add.svg) center center no-repeat;
	}

	.group-i {
		display: inline-block;
		vertical-align: middle;
		width: 28px;
		height: 28px;
		margin-right: 8px;
		background: url(../assets/images/setting.svg) center center no-repeat;
	}
}

@media screen and (max-width: 360px) {
	.bankgroup-list {
		padding-bottom: 80px;

		.bankgroup-item {
			padding: 16px 12px;

			.accounts-list {
				.account-item {
					padding: 16px 12px;

					.icon-info .day-limit,
					.bank-info .per-limit {
						font-size: 12px !important;
					}
				}
			}

		}
	}
}
</style>
<style lang="less">
.sigle-operation {
	display: flex;
	justify-content: right;

	.cube-switch {
		.cube-switch-input {
			width: 38px;
			height: 18px;
		}

		.cube-switch-ui {
			height: 18px;
			width: 38px;

			&:after {
				width: 18px;
			}
		}

		.cube-switch-input:checked {
			.cube-switch-ui {
				&:after {
					transform: translateX(36px);
				}
			}
		}
	}
}
</style>